import _defineProperty from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { resetComponent } from '../../style';
import { genComponentStyleHook, mergeToken } from '../../theme/internal';

var genQRCodeStyle = function genQRCodeStyle(token) {
  var _Object$assign, _ref;

  var componentCls = token.componentCls;
  return _ref = {}, _defineProperty(_ref, componentCls, Object.assign(Object.assign({}, resetComponent(token)), (_Object$assign = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: token.paddingSM,
    backgroundColor: token.colorWhite,
    borderRadius: token.borderRadiusLG,
    border: "".concat(token.lineWidth, "px ").concat(token.lineType, " ").concat(token.colorSplit),
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden'
  }, _defineProperty(_Object$assign, "& > ".concat(componentCls, "-mask"), _defineProperty({
    position: 'absolute',
    insetBlockStart: 0,
    insetInlineStart: 0,
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    color: token.colorText,
    lineHeight: token.lineHeight,
    background: token.QRCodeMaskBackgroundColor,
    textAlign: 'center'
  }, "& > ".concat(componentCls, "-expired"), {
    color: token.QRCodeExpiredTextColor
  })), _defineProperty(_Object$assign, '&-icon', {
    marginBlockEnd: token.marginXS,
    fontSize: token.controlHeight
  }), _Object$assign))), _defineProperty(_ref, "".concat(componentCls, "-borderless"), {
    borderColor: 'transparent'
  }), _ref;
};

export default genComponentStyleHook('QRCode', function (token) {
  return genQRCodeStyle(mergeToken(token, {
    QRCodeExpiredTextColor: 'rgba(0, 0, 0, 0.88)',
    QRCodeMaskBackgroundColor: 'rgba(255, 255, 255, 0.96)'
  }));
});